/**
 * Reading the hand-off URL — `/impersonation/<impersonation_grant_id>#<handoff_token>` (plan-002
 * RB-18, design §15.7.8).
 *
 * Both readers are total functions over untrusted input from the address bar: they return `null`
 * for anything that is not exactly the documented shape, and the screen refuses on `null` without
 * calling the API. The token is 32 random bytes in base64url (43 characters), the same shape as
 * the customer cookie it will be rotated into.
 */

const HANDOFF_TOKEN_SHAPE = /^[A-Za-z0-9_-]{43}$/;
const GRANT_ID_SHAPE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The token from a location hash, with or without its leading `#`. */
export function handoffTokenOf(hash: string): string | null {
  const bare = hash.startsWith("#") ? hash.slice(1) : hash;
  return HANDOFF_TOKEN_SHAPE.test(bare) ? bare : null;
}

/** The grant id from the path parameter. */
export function impersonationGrantIdOf(parameter: string | undefined): string | null {
  if (parameter === undefined) return null;
  return GRANT_ID_SHAPE.test(parameter) ? parameter.toLowerCase() : null;
}
